import { render } from "./EditShip.vue?vue&type=template&id=4e1717aa"
import script from "./EditShip.vue?vue&type=script&lang=js"
export * from "./EditShip.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__